import { render, staticRenderFns } from "./BaseAutocomplete.vue?vue&type=template&id=2d3ce53c&scoped=true&"
import script from "./BaseAutocomplete.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseAutocomplete.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseAutocomplete.vue?vue&type=style&index=0&id=2d3ce53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3ce53c",
  null
  
)

export default component.exports